import {
  IQuoteListParams,
  IQuoteListResponse,
  IQuoteResponse,
  IQuotesResponse,
} from 'shared';

import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';

export const quotesApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchQuote: builder.query<IQuoteResponse, { organisationId: string; quoteId: string }>({
      query: ({ organisationId, quoteId }) => ({
        url: `quotes/${quoteId}`,
        method: `GET`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      providesTags: (result, error, { quoteId }) => [{
        type: CacheTags.Quotes,
        id: quoteId,
      }],
    }),
    fetchQuoteList: builder.query<IQuoteListResponse, IQuoteListParams & { organisationId: string }>({
      query: ({ organisationId, ...params }) => ({
        url: `quotes/list`,
        method: `GET`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
        params,
      }),
      providesTags: [{
        type: CacheTags.Quotes,
      }],
    }),
    fetchQuotes: builder.query<IQuotesResponse, { organisationId: string; contactId?: number }>({
      query: ({ organisationId, contactId }) => ({
        url: `quotes`,
        method: `GET`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
        params: contactId ? { contactId } : undefined,
      }),
      providesTags: [{
        type: CacheTags.Quotes,
      }],
    }),
    syncQuotes: builder.mutation<void, { organisationId: string }>({
      query: ({ organisationId }) => ({
        url: `quotes/sync/all`,
        method: `POST`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      invalidatesTags: [{ type: CacheTags.Quotes }, { type: CacheTags.Organisations }],
    }),
  }),
});

export const {
  useFetchQuoteQuery,
  useFetchQuotesQuery,
  useFetchQuoteListQuery,
  useSyncQuotesMutation,
} = quotesApi;
